import { axios } from '../util/request'
axios.defaults.headers.common['Content-Type'] = 'application/json';
const BASE_URL = process.env.NODE_ENV === 'development' ? '/api' : '/api'
const BASE_SCURL = process.env.NODE_ENV === 'development' ? '/scApi' : '/scApi'

import Qs from 'qs'

const API_DATA = {
  //获取用户信息
  userInfo: () => {
    return axios({
      url: `${BASE_URL}/user/mp/detail`,
      method: 'get'
    })
  },
  //获取vip信息
  isVip: () => {
    return axios({
      url: `${BASE_URL}/lecturer/isVip`,
      method: 'GET',
      params: {
        num:Math.random()
      }
    })
  },
  // 获取所有提示语列表
  dictionariesAll: () => {
    return axios({
      url: `${BASE_URL}/dictionaries/all`,
      method: 'get'
    })
  },
  // 获取回答文章列表
  getAnswer: (keyWord,title,page) => {
    return axios({
      url: `${BASE_URL}/dataCenter/getAnswer`,
      method: 'get',
      params:{
        keyWord,
        title,
        page,
        size:10
      }
    })
  },
  //获取回答文章详情
  getDataCenter: (articleId,questionId,keyWord) => {
    return axios({
      url: `${BASE_URL}/dataCenter/detail`,
      method: 'post',
      params:{
        articleId,
        questionId,
        keyWord
      }
    })
  },

  //已解决为解决
  getFeedback: ( articleId,questionId,feedback,chatId) => {
    return axios({
      url: `${BASE_URL}/chat/feedback`,
      method: 'POST',
      params:{
        articleId,
        questionId,
        feedback,
        chatId
      }
    })
  },
  //2.3 添加聊天记录（已完成）
  getAdd: () => {
    return axios({
      url: `${BASE_URL}/chat/add`,
      method: 'POST',
      params:{
        speakerType: 0,
        chatType: 2,
        content: '如何查询增值税发票真伪'
      }
    })
  },
  //3.1 获取今日答疑所有课程
  getToday: () => {
    return axios({
      url: `${BASE_URL}/lecturer/getToday?r=`+Math.random(),
      method: 'GET'
    })
  },
  //3.2 获取更多课程分页
  getOtherLecture: () => {
    return axios({
      url: `${BASE_URL}/lecturer/getOtherLecture?r=`+Math.random(),
      method: 'GET'
    })
  },

  //liyanze分支增加收藏接口
  doGetData :(data,url) =>{
    return axios({
      url:`${BASE_SCURL}/` + url + data,
      methosd:'GET',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
    })
  },
  doPostData :(data,url) => {
    return axios({
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      url: `${BASE_SCURL}/`+ url,
      method: 'POST',
      params:data,
    })
  },
  doGetDataSBW :(data,url) =>{
    return axios({
      url:`${BASE_URL}/` + url + data,
      methosd:'GET',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
    })
  },
  doPostDataSBW :(data,url) => {
    data = Qs.stringify(data)

    return axios({
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      url: `${BASE_URL}/`+ url,
      method: 'POST',
      data:data,
    })
  },
  getAnswerFive: (title,page,size) => {
    return axios({
      url: `${BASE_URL}/dataCenter/getAnswer`,
      method: 'get',
      params:{
        title,
        page,
        size:5
      }
    })
  },
}
export { API_DATA }


